import { TransactionOrSplit } from '../../reducers/admin/allTransactions.slice'
import { useCallback, useState } from 'react'
import { Grid } from 'semantic-ui-react'
import { Button, Text } from '../BaseComponents'
import { DATE_FORMATS_LUXON } from '../../utils/dateHelpers'
import { DateTime } from 'luxon'
import { formatCurrencyFromCents } from '../../utils/currencyHelpers'
import DeprecatedTransactionNoteModal from '@/features/transactions/lists/DeprecatedTransactionNoteModal'
import './TransactionRow.scss'

export const TransactionRow = ({
  transaction,
  onUpdate,
}: {
  transaction: TransactionOrSplit
  onUpdate: () => Promise<void>
}) => {
  const [modalOpen, setModalOpen] = useState(false)
  const { date, description, notes, amountInCents } = transaction

  const onClose = useCallback(
    async (updated: boolean) => {
      if (updated) {
        await onUpdate()
      }
      setModalOpen(false)
    },
    [onUpdate]
  )

  return (
    <Grid.Row verticalAlign="middle" className="transaction-row-body">
      <Grid.Column width={3}>
        <Text as="bodyLg">
          {DateTime.fromISO(date)
            .toUTC()
            .toFormat(DATE_FORMATS_LUXON.DISPLAY_ABBR)}
        </Text>
      </Grid.Column>
      <Grid.Column width={8} className="note-body">
        <Text as="bodyLg">{description}</Text>
        <Text as="bodySm">{notes}</Text>
      </Grid.Column>
      <Grid.Column width={5}>
        <div className="currency-note-grid">
          <Text as="bodyLg" textAlign="right">
            {formatCurrencyFromCents(amountInCents)}
          </Text>
          <Button
            variant="link"
            onClick={() => setModalOpen(true)}
            className="note-button"
          >
            {notes ? 'Edit Note' : 'Add Note'}
          </Button>
        </div>
      </Grid.Column>
      {modalOpen && (
        <DeprecatedTransactionNoteModal
          transaction={transaction}
          open={modalOpen}
          close={onClose}
        />
      )}
    </Grid.Row>
  )
}
